import { render, staticRenderFns } from "./MedicalRecordUpload.vue?vue&type=template&id=0d492166&scoped=true&"
import script from "./MedicalRecordUpload.vue?vue&type=script&lang=js&"
export * from "./MedicalRecordUpload.vue?vue&type=script&lang=js&"
import style0 from "./MedicalRecordUpload.vue?vue&type=style&index=0&id=0d492166&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d492166",
  null
  
)

export default component.exports